/* Tysk katalog for locale-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'sup.archiveBody': 'Möchtest du {name} ins Archiv verschieben? Der Lieferant wird in aktiven Lieferantenlisten ausgeblendet, aber Rechnungen, Zahlungen und Verlauf bleiben erhalten. Du kannst den Lieferanten später wieder öffnen.',
  'cust.title': 'Kunden',
  'cust.subtitle': 'Alle deine Kunden an einem Ort',
  'cust.searchPh': 'Nach Kunde oder Betrag suchen',
  'cust.titleHelp': 'Dein Kundenverzeichnis — alle Kunden mit Kontaktdaten, offenen Beträgen und Gesamtumsatz. Tippe auf einen Kunden, um Nachverfolgung und Rechnungen zu sehen.',
  'cust.searchHelp': 'Durchsuche die Kunden nach Name, E-Mail, Gesamtumsatz oder offenem Betrag.',
  'cust.uploadHelp': 'Kunden aus einer Datei importieren.',
  'cust.downloadHelp': 'Kundenliste als CSV oder Excel herunterladen.',
  'cust.addHelp': 'Neuen Kunden mit Kontaktdaten und Nachverfolgungsstatus hinzufügen.',
  'cust.filterHelp': 'Filtere die Kunden nach Status (aktiv, Interessent, Angebot gesendet, pausiert), danach, ob sie offene Beträge haben, und ob archivierte angezeigt werden sollen.',
  'cust.listHelpTitle': 'Die Kundenliste',
  'cust.listHelp': 'Jede Zeile ist ein Kunde mit Kundennr., Org.-Nr., E-Mail, Telefon, offenem Betrag und Gesamtumsatz. Tippe auf eine Zeile, um den Kunden zu öffnen.',
  'cust.filterOther': 'Sonstiges',
  'cust.filterWithOutstanding': 'Nur mit offenen Beträgen',
  'cust.filterShowArchive': 'Archiv anzeigen',
  'cust.archived': 'Archiviert',
  'cust.followUpInline': 'Nachverfolgung {date}',
  'cust.col.customer': 'Kunde',
  'cust.col.number': 'Kundennr.',
  'cust.col.org': 'Org.-Nr.',
  'cust.col.email': 'E-Mail',
  'cust.col.phone': 'Telefon',
  'cust.col.outstanding': 'Offen',
  'cust.col.totalSales': 'Gesamtumsatz',
  'cust.outstandingInline': 'Offen {amount}',
  'cust.balance.customerOwes': 'Der Kunde schuldet dir {amount}',
  'cust.balance.youOwe': 'Du schuldest dem Kunden {amount}',
  'cust.balance.settled': 'Ausgeglichen',
  'cust.followUp': 'Nachverfolgung',
  'cust.followUpHelp': 'Status, nächstes Nachverfolgungsdatum, Notizen und letzte Aktivitäten des Kunden. Nutze den Chat-Button, um Gespräche zu protokollieren und Angebote zu erstellen.',
  'cust.dialogTitle': 'Kundendialog',
  'cust.dialogHelp': 'Öffne ein Gespräch mit dem Kunden — protokolliere Nachrichten und erstelle eine Angebotsgrundlage, die du in ein Angebot umwandeln kannst.',
  'cust.openChat': 'Chat öffnen',
  'cust.startChat': 'Chat starten',
  'cust.nextFollowUp': 'Nächste Nachverfolgung',
  'cust.noFollowUpDate': 'Kein Datum festgelegt',
  'cust.status': 'Status',
  'cust.salesTitle': 'Verkäufe an den Kunden',
  'cust.salesHelp': 'Alle Rechnungen und Gutschriften des Kunden. Filtere nach alle, nicht bezahlt oder bezahlt — und öffne eine Rechnung direkt mit „Öffnen“.',
  'cust.salesAll': 'Alle',
  'cust.salesUnpaid': 'Nicht bezahlt',
  'cust.salesPaid': 'Bezahlt',
  'cust.salesTotal': 'Gesamt',
  'cust.noSalesMatch': 'Keine Verkäufe entsprechen dem Filter.',
  'cust.creditNote': 'Gutschrift',
  'cust.invoice': 'Rechnung',
  'cust.dueOn': 'Fällig am {date}',
  'cust.open': 'Öffnen',
  'cust.pageRange': '{from}-{to} von {total}',
  'cust.prev': 'Zurück',
  'cust.next': 'Weiter',
  'cust.act.newInvoice': 'Neue Rechnung',
  'cust.act.newInvoiceHelp': 'Neue Rechnung mit diesem Kunden bereits ausgewählt starten.',
  'cust.act.edit': 'Bearbeiten',
  'cust.act.editHelp': 'Kontaktdaten, Status und Nachverfolgung des Kunden ändern.',
  'cust.act.merge': 'Zusammenführen',
  'cust.act.mergeHelp': 'Zwei doppelt erfasste Kunden zusammenführen — Verkäufe und offene Beträge werden bei einem Kunden zusammengefasst.',
  'cust.act.archive': 'Ins Archiv verschieben',
  'cust.act.archiveHelp': 'Kunden in aktiven Listen ausblenden. Rechnungen, Zahlungen und Verlauf bleiben erhalten.',
  'cust.act.menu': 'Aktion',
  'cust.archiveTitle': 'Ins Archiv verschieben?',
  'cust.archiveBody': 'Möchtest du {name} ins Archiv verschieben? Der Kunde wird in aktiven Kundenlisten ausgeblendet, aber Rechnungen, Zahlungen und Verlauf bleiben erhalten.',
  'cust.archiveStillUsed': 'Der Kunde wird noch an anderer Stelle verwendet',
  'cust.archiveGroup': '{n} Kundengruppe',
  'cust.archiveGroups': '{n} Kundengruppen',
  'cust.archiveSubscription': '{n} Abonnement',
  'cust.archiveSubscriptions': '{n} Abonnements',
  'cust.archiveAnd': ' und ',
  'cust.merge.title': 'Kunden zusammenführen',
  'cust.merge.keep': 'Wird behalten',
  'cust.merge.remove': 'Wird zusammengeführt und entfernt',
  'cust.merge.swap': 'Tauschen, welcher Kunde behalten wird',
  'cust.merge.after': 'Nach dem Zusammenführen',
  'cust.merge.name': 'Kundenname',
  'cust.merge.totalSales': 'Gesamtumsatz',
  'cust.merge.notConnected': 'Das Zusammenführen ist noch nicht mit dem Backend verbunden.',
  'cust.merge.done': 'Die Kunden wurden zusammengeführt',
  'cust.merge.failed': 'Die Kunden konnten nicht zusammengeführt werden.',
  'cust.form.name': 'Kundenname',
  'cust.form.namePh': 'Z. B. Beispiel AS',
  'cust.form.orgOptional': 'Org.-Nummer (optional)',
  'cust.form.org': 'Org.-Nummer',
  'cust.form.address': 'Adresse',
  'cust.form.addressPh': 'Straße und Hausnummer',
  'cust.form.zip': 'PLZ',
  'cust.form.city': 'Ort',
  'cust.form.cityPh': 'Ort',
  'cust.form.crm': 'Kundenstatus',
  'cust.form.nextLabel': 'Nächste: {date}',
  'cust.form.noFollowUp': 'Keine Nachverfolgung',
  'cust.form.dupTitle': 'Das gibt es bereits bei einem anderen Kunden',
  'cust.form.dupName': '{names} hat denselben Namen.',
  'cust.form.dupOrg': '{names} hat dieselbe Organisationsnummer.',
  'cust.form.dupEmail': '{names} hat dieselbe E-Mail-Adresse.',
  'cust.form.dupPhone': '{names} hat dieselbe Telefonnummer.',
  'cust.form.dupUnnamed': 'Ein Kunde ohne Namen',
  'cust.form.dupBody': 'Der Kunde wird wie gewohnt gespeichert. Wenn es derselbe Kunde ist, kannst du die beiden über die Kundenkarte in der Liste zusammenführen.',
  'cust.form.contacts': 'Ansprechpartner',
  'cust.form.contactsSub': 'Können als Empfänger ausgewählt werden, wenn du eine Rechnung, ein Angebot oder eine Quittung sendest.',
  'cust.form.addContact': 'Ansprechpartner hinzufügen',
  'cust.form.editContact': 'Ansprechpartner bearbeiten',
  'cust.form.contactFallback': 'Ansprechpartner {n}',
  'cust.form.removeContact': 'Ansprechpartner entfernen',
  'cust.form.contactTitle': 'Ansprechpartner',
  'cust.form.newTitle': 'Neuer Kunde',
  'cust.form.editTitle': 'Kunde bearbeiten',
  'cust.form.saveContact': 'Speichern',
  'cust.form.contactName': 'Name',
  'cust.form.contactNamePh': 'Z. B. Kari Nordmann',
  'cust.form.contactRole': 'Rolle',
  'cust.form.contactRolePh': 'Z. B. Buchhaltung',
  'cust.form.defaultRef': 'Feste Rechnungsreferenz',
  'cust.form.defaultRefPh': 'Z. B. Projektnummer, Bestellung oder Abteilung',
  'cust.form.creditLimit': 'Kreditlimit',
  'cust.form.creditLimitHint': 'Wird in der Abstimmung verwendet, um den offenen Saldo des Kunden mit der eigenen Kreditrichtlinie des Unternehmens zu vergleichen. Ein Limit sperrt nie die Rechnungsstellung.',
  'cust.form.creditLimitPh': 'Z. B. 60000',
  'cust.form.note': 'Kundennotiz',
  'cust.form.notePh': 'Notiz zum Kunden',
  'cust.form.activity': 'Aktivitätsnotiz hinzufügen',
  'cust.form.activityPh': 'Kunden angerufen, Preisaktualisierung gesendet…',
  'cust.form.update': 'Kunde aktualisieren',
  'cust.form.save': 'Kunde speichern',
  'cust.crm.prospect': 'Interessent',
  'cust.crm.quoteSent': 'Angebot gesendet',
  'cust.crm.active': 'Aktiver Kunde',
  'cust.crm.pause': 'Pausiert',
  'cust.chat.scope.all': 'Gesamtes Gespräch',
  'cust.chat.scope.to': 'An Kunden',
  'cust.chat.scope.from': 'Vom Kunden',
  'cust.chat.scope.internal': 'Interne Notizen',
  'cust.chat.helpAll': 'Du siehst jetzt das gesamte Gespräch.',
  'cust.chat.helpTo': 'Du siehst jetzt Nachrichten, die du gesendet hast.',
  'cust.chat.helpFrom': 'Du siehst jetzt Nachrichten vom Kunden.',
  'cust.chat.helpInternal': 'Das sind deine internen Notizen im Dialog.',
  'cust.chat.threadsHelpTitle': 'Gespräche',
  'cust.chat.threadsHelp': 'Jeder Kunde kann mehrere Gespräche haben. Wechsle hier zwischen ihnen oder starte einen neuen Dialog für eine neue Anfrage.',
  'cust.chat.conversation': 'Gespräch',
  'cust.chat.filterTitle': 'Gespräch filtern',
  'cust.chat.filterHelp': 'Wähle, was im Fenster unten angezeigt wird: das gesamte Gespräch, Nachrichten, die du gesendet hast, Nachrichten vom Kunden oder interne Notizen.',
  'cust.chat.windowTitle': 'Gesprächsfenster',
  'cust.chat.windowHelp': 'Die Nachrichten im Dialog. Was du sendest, erscheint rechts, Nachrichten des Kunden und interne Notizen links. Zieh den unteren Rand, um das Fenster zu vergrößern.',
  'cust.chat.internal': 'Intern',
  'cust.chat.newInternalTitle': 'Neue interne Notiz',
  'cust.chat.saveInDialog': 'Im Dialog speichern',
  'cust.chat.saveMessage': 'Nachricht speichern',
  'cust.chat.sendMessage': 'Nachricht senden',
  'cust.chat.newTitle': 'Neue Nachricht',
  'cust.chat.newHelp': 'Schreib eine Antwort an den Kunden, füge eine erhaltene Nachricht ein oder notiere etwas intern. Der gewählte Gesprächsfilter bestimmt, ob dies an den Kunden gesendet, als Kundennachricht gespeichert oder als interne Notiz gespeichert wird.',
  'cust.chat.draftPh': 'Antwort schreiben, Kundennachricht einfügen oder notieren, was vereinbart wurde...',
  'cust.chat.newDialog': 'Neuer Dialog',
  'cust.chat.quoteTitle': 'Angebotsgrundlage',
  'cust.chat.quoteHelp': 'Füge die im Gespräch vereinbarten Produkte und Preise hinzu. Tippe auf „Angebot erstellen“, um daraus einen Angebotsentwurf mit bereits ausgefülltem Kunden zu machen.',
  'cust.chat.findProduct': 'Produkt/Preis finden',
  'cust.chat.productPh': 'Produktname suchen...',
  'cust.chat.dragToMessage': 'In die Nachricht ziehen',
  'cust.chat.dragTotal': 'Summe in die Nachricht ziehen',
  'cust.chat.dragBasis': 'Gesamte Angebotsgrundlage in die Nachricht ziehen',
  'cust.chat.quoteBasis': 'Gesamte Grundlage',
  'cust.chat.remove': 'Entfernen',
  'cust.chat.total': 'Summe',
  'cust.chat.makeQuote': 'Angebot erstellen',
  'cust.toast.updated': 'Kunde aktualisiert',
  'cust.toast.saved': 'Kunde gespeichert',
  'cust.toast.saveFailed': 'Der Kunde konnte nicht gespeichert werden.',
  'cust.toast.archived': 'Kunde ins Archiv verschoben',
  'cust.toast.archiveFailed': 'Der Kunde konnte nicht archiviert werden.',
  'cust.toast.nothingToExport': 'Keine Kunden zum Exportieren',
  'cust.toast.exportFailed': 'Die Kundenliste konnte nicht exportiert werden.',
  'cust.toast.exported': 'Kundenliste heruntergeladen',
  'cust.toast.noLedgerRows': 'Keine Debitorenzeilen zum Exportieren',
  'cust.toast.ledgerExportFailed': 'Die Debitoren konnten nicht exportiert werden.',
  'cust.toast.ledgerExported': 'Debitoren heruntergeladen',
  'cust.toast.wrongFormat': 'Verwende CSV oder XLSX mit der Plumme-Kundenvorlage.',
  'cust.toast.noneInFile': 'In der Datei wurden keine Kunden gefunden.',
  'cust.toast.imported': '{n} Kunden importiert',
  'cust.toast.importFailed': 'Die Kunden konnten nicht importiert werden.',
  'cust.error.xlsxImport': 'Der XLSX-Import ist noch nicht verfügbar.',
  'cust.error.xlsxExport': 'Der Excel-Export ist noch nicht verfügbar.',
  'cust.export.number': 'Kundennr.',
  'cust.export.name': 'Name',
  'cust.export.org': 'Org.-Nr.',
  'cust.export.email': 'E-Mail',
  'cust.export.phone': 'Telefon',
  'cust.export.address': 'Adresse',
  'cust.export.zip': 'PLZ',
  'cust.export.city': 'Ort',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Nächste Nachverfolgung',
  'cust.export.defaultRef': 'Feste Rechnungsreferenz',
  'cust.export.note': 'Notiz',
  'cust.ledger.code': 'Code',
  'cust.ledger.date': 'Datum',
  'cust.ledger.doc': 'Beleg-/Rechnungsnr.',
  'cust.ledger.type': 'Typ',
  'cust.ledger.due': 'Fälligkeit',
  'cust.ledger.debit': 'Soll',
  'cust.ledger.credit': 'Haben',
  'cust.ledger.balance': 'Saldo nach Zeile',
  'cust.ledger.paid': 'Bezahlt',
  'cust.ledger.remaining': 'Offen',
  'cust.ledger.partial': 'Teilweise bezahlt',
  'cust.ledger.unpaid': 'Nicht bezahlt',
  'cust.ledger.posted': 'Gebucht',
  'cust.ledger.refund': 'Rückzahlung an Kunden',
  'cust.ledger.payment': 'Kundenzahlung',
  'cust.ledger.creditOverpayment': 'Guthaben / Überzahlung',
  'cust.ledger.empty': 'Noch keine Debitorenzeilen.',
  'cust.import': 'Importieren',
  'cust.importFrom': 'Importieren aus',
  'cust.ledgerShort': 'Debitoren',
  'cust.ledger.sheet': 'Debitoren',
  'cust.sheet.customers': 'Kunden',
});
